import * as React from 'react';

function SvgLogOut(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M7.385 12.011a.77.77 0 01.769-.769h6.923v-5c0-1.538-1.624-2.692-3.077-2.692H4.692A2.695 2.695 0 002 6.242v11.539a2.695 2.695 0 002.692 2.692h7.693a2.695 2.695 0 002.692-2.692v-5H8.154a.77.77 0 01-.77-.77zm14.39-.543l-3.846-3.846a.769.769 0 00-1.088 1.087l2.533 2.533h-4.297v1.539h4.297l-2.533 2.533a.77.77 0 101.088 1.087l3.846-3.846a.77.77 0 000-1.087z" })));
}

export default SvgLogOut;
